import { generateTestId } from "@client-shared";

export const setLabelTemplatesTestId = (identifier: string): string => generateTestId("LabelTemplates", identifier);

// Specific testId setters for tests
export const setLabelTemplatesContainerTestId = (): string => setLabelTemplatesTestId("container");
export const setLabelTemplatesTitleTestId = (): string => setLabelTemplatesTestId("title");
export const setLabelTemplatesCardTestId = (id: string): string => setLabelTemplatesTestId(`card-${id}`);
export const setLabelTemplatesUseButtonTestId = (id: string): string => setLabelTemplatesTestId(`use-button-${id}`);
